import { postAsync } from 'common/fetch'
import { EmailRequest } from 'types/serviceTypes'

export const setBuyer = (id: number) => {
  return postAsync(`/service/setbuyer?id=${id}`)
}

export const getEmailRetailViewDefaultText = (emailRequest: EmailRequest) => {
  return postAsync<string>('/api/vehicle/GetEmailRetailViewDefaultText', { body: emailRequest })
}

export const sendEmailRetailView = (emailRequest: EmailRequest) => {
  return postAsync<string>('/api/vehicle/EmailRetailViewByInstanceID', { body: emailRequest })
}
